export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 4.72950430.jpg";